const API_URL = process.env.REACT_APP_API_URL;

export const api = {
	user: {
		login: `${API_URL}auth/login`,
		validateotp: `${API_URL}auth/validateOTP`,
		updatePassword: `${API_URL}admin-master-user/UpdatePassword`,
		forgotPassword: `${API_URL}admin-master-user/ForgetPassword`,
	},
	classes: {
		getclasslist: `${API_URL}classroom/getclassList`,
		addclassdetails: `${API_URL}classroom/addclassDetails`,
		updateclassroom: `${API_URL}classroom/updateclassroom`,
		deleteClass: `${API_URL}classroom/DeleteClass`,
		activateClass: `${API_URL}classroom/updateActiveClassroom`,
	},
	students: {
		FetchStudents: `${API_URL}students/FetchStudents`,
		AddStudents: `${API_URL}students/AddStudents`,
		updateStudents: `${API_URL}students/updateStudents`,
		deleteStudent: `${API_URL}students/Delete`,
		regenerateAccessCode: `${API_URL}students/RegenerateAccessCode`,
	},
	games: {
		fetchgames: `${API_URL}game-maintenance/Games`,
		createGame: `${API_URL}game-maintenance/addGame`,
		updateGame: `${API_URL}game-maintenance/updateGame`,
		gamesQuestions: `${API_URL}game-maintenance/GamesQuestions`,
		addGameQuestions: `${API_URL}game-maintenance/addGameQuestions`,
		updateGameQuestions: `${API_URL}game-maintenance/updateGameQuestions`,
		deleteQuestion: `${API_URL}game-maintenance/DeleteQuestion`,
		updateGameSequence: `${API_URL}game-maintenance/sequence`,
		updateQuestionSequence: `${API_URL}game-maintenance/GameQuestionsSequence`,
	},
	medias: {
		fetchmedialist: `${API_URL}media-upload/allMedia`,
		addMedia: `${API_URL}media-upload/addMedia`,
		updateMedia: `${API_URL}media-upload/updateMedia`,
		deleteMedia: `${API_URL}media-upload/deleteMedia`,
	},
	admins: {
		fetchadminslist: `${API_URL}admin-master-user/AllAdmins`,
		createadmin: `${API_URL}admin-master-user/insert`,
		updateadmin: `${API_URL}admin-master-user/update`,
		deleteadmin: `${API_URL}admin-master-user`,
	},
	activities: {
		fetchActivities: `${API_URL}favorite-activities/favoriteActivities`,
		createActivity: `${API_URL}favorite-activities/addFavoriteActivities`,
		updateActivity: `${API_URL}favorite-activities/updateFavoriteActivities`,
		deleteActivity: `${API_URL}favorite-activities/DeleteFavoriteActivity`,
	},
	popupmessage: {
		fetchPopups: `${API_URL}popupmessage/allpopmessages`,
		createPopup: `${API_URL}popupmessage/addpopupmessage`,
		updatePopup: `${API_URL}popupmessage/updatepopupmessage`,
		deletePopup: `${API_URL}popupmessage/deletepopupmessage`,
	},
	admessage: {
		fetchAdmessages: `${API_URL}ad-messages/getadmessages`,
		createAdmessage: `${API_URL}ad-messages/createadmessage`,
		updateAdmessage: `${API_URL}ad-messages/updateadmessage`,
		deleteAdmessage: `${API_URL}ad-messages/deleteadmessage`,
	},
	blockedword: {
		fecthBlockedwords: `${API_URL}chat-blocked-words/getchatblockedwords`,
		createBlockedword: `${API_URL}chat-blocked-words/createchatblockedwords`,
		updateBlockedword: `${API_URL}chat-blocked-words/updatechatblockedwords`,
		deleteBlockedword: `${API_URL}chat-blocked-words/deletechatblockedwords`,
	},
	chatmessage: {
		fetchChat: `${API_URL}chat-messages/getchatmessages`,
		sendChat: `${API_URL}chat-messages/postchatmessages`,
	},
	chatmonitoring: {
		fetchActiveClasses: `${API_URL}classroom/GetActiveclasses`,
		getActiveStudents: `${API_URL}chat-messages/getallstudents`,
		updatestudentBlocks: `${API_URL}chat-monitoring/student-block-unblock`,
		fetchFlaggedMessages: `${API_URL}chat-monitoring/flagged_messages`,
		fetchReportedMessages: `${API_URL}chat-monitoring/get-Reported-Student`,
		updateAwardCoins: `${API_URL}chat-monitoring/award-coins`,
		getchatusername: `${API_URL}chat-monitoring/GetAllChatUserName`,
		updateChatusername: `${API_URL}chat-monitoring/InsertChatUserName`,
		fetchAppconfigs: `${API_URL}configuration/getconfiguration`,
	},
	chathistory: {
		clearChat: `${API_URL}game-history/clearChat_GameHistory`,
		userSelections: `${API_URL}game-history/userSelections`,
		getGameStat: `${API_URL}game-history/getGamestatHistory`,
	},
	fonts: {
		fetchAllFonts: `${API_URL}game-fonts/getAllGameFonts`,
		uploadFonts: `${API_URL}game-fonts/insertGameFonts`,
		updateFont: `${API_URL}game-fonts/updateGameFont`,
		deleteFont: `${API_URL}game-fonts/deleteGameFont`,
	},
	organization: {
		getBranding: `${API_URL}organization/branding`,
		updateBranding: `${API_URL}organization/branding`,
	},
};